import { useEffect, useState } from 'react'
import { pjGetProject } from '../../db/api.js'
import { projectTaskView } from '../../lib/operationKanban.js'
import OperacaoTaskList from './OperacaoTaskList.jsx'

// Resolve links through the current account before showing the shared task workspace.
export default function OperationProjectTasks({ projectId, data, query, onBack, onProjectChange, onRefresh }) {
  const [project, setProject] = useState(null)
  const [error, setError] = useState(null)
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setError(null)
    pjGetProject(projectId).then(value => {
      if (active) setProject({ ...value, titulo: value.nome })
    }).catch(e => { if (active) setError(e.message) })
    return () => { active = false }
  }, [projectId, retry])
  if (error) return <div className="ov-empty" role="alert">{error}<button type="button" className="od-btn" onClick={() => setRetry(v => v + 1)}>Tentar novamente</button><button type="button" className="od-btn" onClick={onBack}>Voltar aos projetos</button></div>
  if (!project) return <div className="ov-empty" role="status">Carregando projeto…</div>
  return <OperacaoTaskList data={data} query={query} kind="todas" project={project}
    contextFilters={{ view: projectTaskView(project, 'all') }} onBack={onBack} onRefresh={onRefresh}
    onProjectChange={next => { if (next.id === projectId) setProject(next); else onProjectChange(next.id) }} />
}
